import { InputNumber } from "antd"
import { AttrEditorProps } from "./index"
import { mm2px, px2mm } from "@/utils/size"
import { useEffect, useState } from "react"


export function MMNumberEditor(props: AttrEditorProps) {
  const {value: initValue, onChange} = props;
  const [value, setValue] = useState(px2mm(initValue))

  useEffect(() => {
    setValue(px2mm(initValue))
  }, [initValue])

  const handleChange = (e) => {
    const mmVal = mm2px(e.target.value)
    onChange(mmVal)
  }
  return <InputNumber value={value} style={{width: 150}} controls={false} onBlur={handleChange} addonAfter={'mm'}/>
}